
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Paginator: () => import("@/components/Paginator.vue"),
    SortColumn: () => import("@/components/SortColumn.vue")
  },
  computed: {},
  filters: {},
  watch: {}
})
export default class CompanySelect extends Vue {
  dictionary: any = {};
  title: string = "Seleccionar contrato";
  selectedCompany: string = "";
  companies: any = [];
  limit: number = 5;
  totalRows: number = 0;
  sortColumns: Record<string, string> = {
    name: "Empresa",
    owner: "Responsable",
    deletedAt: "Estado"
  };
  currentSort: Record<string, string> = {
    col: "companies",
    dir: "asc"
  };

  async mounted() {
    await this.loadDictionary();
    this.companies = this.$store.state.user.companies;
    this.selectedCompany = this.$store.state.companyId;
  }

  onPageChange(page: number, limit: number) {
    this.limit = limit;
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get("requests/dictionary");
    this.dictionary = response;
  }
  handleSort() {
    this.companies.reverse();
  }
  selectCompany() {
    if (this.selectedCompany) {
      this.$store.commit("setCompanyId", this.selectedCompany);
      this.$router.go(0);
    //   this.$router.push("/dashboard");
      
    }
  }
  logOut() {
    this.$store.commit("logout");
  }
}
